// extracted by mini-css-extract-plugin
export default {"container":"DrawerContent_container__njsFb","noContent":"DrawerContent_noContent__ZW5Yc"};